import axios from "axios";
import { auth } from "@/shared/lib/firebase";
import handleError from "./error_handler";

const PROJECT_ID = import.meta.env.VITE_APP_PROJECT_ID;
const REGION = 'asia-south1';

if (!PROJECT_ID) {
  console.warn('[axiosClient] VITE_APP_PROJECT_ID is not set — check your .env file');
}

// Dev → local emulator, otherwise → Cloud Functions
const baseURL = import.meta.env.DEV
  ? `http://127.0.0.1:5001/${PROJECT_ID}/${REGION}`
  : `https://${REGION}-${PROJECT_ID}.cloudfunctions.net`;

console.log('[axiosClient] baseURL:', baseURL);

const axiosClient = axios.create({
  baseURL,
  headers: {
    "Content-Type": "application/json",
  },
});

axiosClient.interceptors.request.use(async (config) => {
  const user = auth.currentUser;
  if (user) {
    const token = await user.getIdToken();
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

axiosClient.interceptors.response.use(
  (response) => response,
  (error) => {
    const err = handleError(error)
    return Promise.reject(err);
  },
);

export default axiosClient;
